<template>
  <div v-if="Object.entries(timeTable).length" class="container">
    <!-- <div class="card-group"> -->

	<div class="date-selector">
		<div class="right-arrow" @click="changeDate(-1)" :class="{ 'hidden-arrow': !hasRightArrow }">❮</div>
		<h1 class="date-title">{{ formattedDayText }}</h1>
		<div class="left-arrow" @click="changeDate(1)" :class="{ 'hidden-arrow': !hasLeftArrow }">❯</div>
	</div>

	<div class="time-table" 
		:style="{ 'grid-template-columns': `6em repeat(${placesOnThisDay.size || 6}, minmax(140px, 1fr))`}"> 
		<span v-for="(place, index) in placesOnThisDay"
			:style="{ 'grid-area': `1 / ${index+2}` }"
			:key="place">
			{{place}}
		</span>

		<span v-for="hour in hoursTable"
			:key="hour"
			:class="classNameFromHour(hour)"
			 :style="{ 'grid-area': gridAreaFromHour(hour) }">
			{{ innerTextFromHour(hour) }}
		</span>

		<app-display-screening 
			 :v-if="placesMapLoaded"
			 v-for="screening in screeningsOnThisDay" 
			 :key="screening.movie.id+screening.date"
			 :minHour="minHour"
			 :hoursAmount="hoursAmount"
			 :placeToColumnMap="placeToColumnMap"
			 :screening="screening"
			 :placesMapLoaded="placesMapLoaded">
		</app-display-screening>
	</div>

  </div><!-- .container -->
  <div v-else>
    <p class="text-center"> Loading ⏳ </p>
  </div>

</template>

<script>
import AppDisplayScreening from './AppDisplayScreening.vue';

export default {
	components: {
		'app-display-screening': AppDisplayScreening
	},
	data() {
		return {
			searchTerm: '',
			minHour: 10,
			hoursAmount: 15,
			timeTable: {},
			currentDayIndex: 0,
			datesList: [],
			placesMapLoaded: false,
		};
	},
	mounted() {
		this.emitter.on('filteredPosts', data => {
			this.timeTable = {}
			this.processData(data);
		});
		this.emitter.on('searchTermChanged', data => {
			this.searchTerm = data;
		});
		this.emitter.on('changedDate', date => {
			let newIndex = this.datesList.findIndex(dateString => dateString.match(date))
			this.currentDayIndex = newIndex
		})
		this.emitter.emit('getFilteredPosts')
	},
	methods: {
		processData(movies) {
			let dates = new Set()
			movies.forEach(movie => {
				if (!movie['custom_fields']['screening_hours_and_events']) return;
				let screenings = movie['custom_fields']['screening_hours_and_events']
				screenings.forEach(screening => {
					if (!screening.time || !screening.where) return
					screening.movie = movie
					screening.where = screening.where.trim().replace(/\s\s/, ' ')
					let screeningDate = screening.date.replace(/<br\/> /g, '')
					dates.add(screeningDate)
					if (this.timeTable[screeningDate]) this.timeTable[screeningDate].push(screening)
					else this.timeTable[screeningDate] = [screening]
				})
			});
			this.placesMapLoaded = true
			this.datesList = Array.from(dates)
			this.datesList.sort(this.sortDates)
		},
		sortPlaces(a ,b) {
			if (a.toLowerCase() < b.toLowerCase()) return -1;
			if (a.toLowerCase() > b.toLowerCase()) return 1;
			return 0;
		},
		sortDates(a ,b) {
			let [_a, aDay, aMonth] = a.match(/(\d{2})\.(\d{2})/)
			let [_b, bDay, bMonth] = b.match(/(\d{2})\.(\d{2})/)
			return ((aMonth*100)+aDay)-((bMonth*100)+bDay)
		},
		changeDate(offest) {
			this.currentDayIndex += offest;
			this.emitter.emit('resetDatesFilter', true)
		},
		classNameFromHour(hour) {
			if (hour>=24) hour-=24
			return 'time-'+hour.toString().replace('.', '-') 
		},
		innerTextFromHour(hour) {
			if (hour>=24) hour-=24
			return hour%1==0? hour+':00':''
		},
		gridAreaFromHour(hour) {
			let row = (hour*4)-(this.minHour*4)+2
			return `${row} / 1`
		}
	},
	computed: {
		hasLeftArrow() {
			return this.currentDayIndex < this.datesList.length-1
		},
		hasRightArrow() {
			return this.currentDayIndex > 0
		},
		formattedDayText() {
			if (!this.datesList[this.currentDayIndex]) return ''
			return this.datesList[this.currentDayIndex].replace('יום ', '').trim()
		},
		screeningsOnThisDay() {
			return this.timeTable[this.datesList[this.currentDayIndex]]
		},
		placesOnThisDay() {
			if (!this.screeningsOnThisDay) return []
			let places = this.screeningsOnThisDay.map(screening => screening.where)
			places.sort(this.sortPlaces)
			return new Set(places)
		},
		hoursTable() {
			let hoursTable = []
			for (let i=0; i<this.hoursAmount; i++) {
				hoursTable.push(this.minHour+i)
				hoursTable.push(this.minHour+i+0.25)
				hoursTable.push(this.minHour+i+0.5)
				hoursTable.push(this.minHour+i+0.75)
			}
			return hoursTable
		},
		placeToColumnMap() {
			return Array.from(this.placesOnThisDay).reduce((map, place, index) => {
				map[place] = index+2;
				return map;
			}, {})
		}
	}
};
</script>

<style scoped>

.card-group {
	gap: 20px;
}

.container {
	padding-right: 0;
}

.date-selector {
	display: flex;
	align-items: center;
}

.date-title {
	padding: 0;
	margin: 0;
	min-width: 32rem;
	text-align: center;
}
.date-selector div[class$="arrow"] {
	margin-bottom: 0.2em;
	padding-inline: 16px;
	cursor: pointer;
	opacity: 1;
	transition: 200ms ease-in-out;
}
.date-selector div[class$="arrow"].hidden-arrow {
	opacity: 0;
	pointer-events: none;
}
.date-selector div[class$="arrow"]:hover { 
	padding-bottom: 5px;
}

.time-table {
	width: 100%;
	border: 1px solid black;
	display: grid;
	grid-template-columns: 6em repeat(7, minmax(140px, 1fr));
	padding: 5px;
	gap: 2px;
	overflow-x: scroll;
}

.time-table .place-1 { grid-area: 1 / 2; }
.time-table .place-2 { grid-area: 1 / 3; }
.time-table .place-3 { grid-area: 1 / 4; }
.time-table .place-4 { grid-area: 1 / 5; }
.time-table .place-5 { grid-area: 1 / 6; }
.time-table .place-6 { grid-area: 1 / 7; }
.time-table .place-7 { grid-area: 1 / 8; }

.time-table span {
	text-align: center;
}

.time-table span[class^="place"] {
	font-size: 1.5em;
	display: flex;
	justify-content: center;
	align-items: center;
}

.time-table span[class^="time"] {
	font-size: 1.3em;
	min-height: 30px;
}

.movie-card {
	border: 1px solid black;
	background-color: white;
	min-height: 30px;
	grid-row-end: span 4;
}


</style>
